export default __webpack_public_path__ + "static/media/desktop-pan.2d138aef.png";